import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { ApiService } from '../../services/api.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  standalone: false,
  selector: 'app-idex-rfp',
 
  templateUrl: './idex-rfp.component.html',
  styleUrl: './idex-rfp.component.scss'
})
export class IdexRfpComponent {
  @Input() stepDetails: any;
  @Input() step: any;
  payload: any;
  // @Output() routeConfig: EventEmitter<any> = new EventEmitter();
  @Output() IRA: EventEmitter<any> = new EventEmitter();
  @Output() routeConfig = new EventEmitter<any>();
  @Output() stepCompleted = new EventEmitter<void>();
  @Input() schemeType: any;
  @Input() proposalId: any;
  isEditorDisabled: boolean = false;
  
  isSubmitting = false;

  constructor(
    private fb: FormBuilder,
    private messageService: MessageService,
    private api: ApiService,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    

    this.route.queryParams.subscribe((params: any) => {
      this.payload = {
        proposal_id: params['id'],
        proposal_name: params['name'],
        proposal_step: params['step']
      };

    
    });
  }
    ngAfterViewInit() {
    setTimeout(() => {
      if (this.stepDetails?.can_edit) {
         this.isEditorDisabled = false;
      } else {
         this.isEditorDisabled = true;
      }
    }, 3000);
  }
  goToNextStep() {
    this.stepCompleted.emit();
  }
  isAonOpen = true;


}